export default __webpack_public_path__ + "41de4357282bf56de9ef1c690e1a17ce.png";